export default __webpack_public_path__ + "static/media/ModalBG.b09cdc72.svg";